import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { BookingItemsStore } from '@fry/booking/lib/booking-items';

import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';


@Component({
    selector: 'eas-editor-booking-item-tree-create',
    templateUrl: './editor-booking-item-tree-create.component.html',
    styleUrls: ['./editor-booking-item-tree-create.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemTreeCreateComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private bookingItems: BookingItemsStore,
    private itemTreeStore: EditorBookingItemTreeStore
  ) {

  }

  ngOnInit() {
    this.route.queryParamMap.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(queryParamMap => {
      const duplicateId = queryParamMap.get('duplicate');
      const typeId = queryParamMap.get('type');
      if (duplicateId) {
        this.bookingItems.getDuplicate(duplicateId).subscribe(bookingItem => {
          this.itemTreeStore.initializeFromBookingItem(bookingItem);
        });
      } else if (typeId) {
        this.itemTreeStore.initializeEmpty(typeId);
      } else {
        this.itemTreeStore.initializeEmpty();
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
